"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledCallout = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// External
// todo: remove when ie11 becomes unsupported
var IE11StyledCallout = _styledComponents.default.div.withConfig({
  displayName: "Calloutstyles__IE11StyledCallout",
  componentId: "sc-1kua8s0-0"
})(["display:-ms-grid;-ms-grid-columns:auto 1fr;.c-callout-icon{-ms-grid-column:1;}.c-callout-paragraph-text{-ms-grid-column:2;}"]);

var StyledCallout = (0, _styledComponents.default)(IE11StyledCallout).withConfig({
  displayName: "Calloutstyles__StyledCallout",
  componentId: "sc-1kua8s0-1"
})(["align-items:center;padding:", " 0;max-width:", ";.c-callout-paragraph-text{padding:0 0 0 ", ";}@supports (display:grid){&{display:grid;grid-template-areas:\"icon text\";grid-template-columns:auto 1fr;}.c-callout-icon{grid-area:icon;}.c-callout-paragraph-text{grid-area:text;}}"], function (props) {
  return props.theme.standardPadding;
}, function (props) {
  return props.theme.componentSizeLarge;
}, function (props) {
  return props.theme.standardPadding;
});
exports.StyledCallout = StyledCallout;